export const SERVER_VIEWS = {
    NO_AUTH_VIEW: 'NoAuth',
    AUTH_VIEW: 'Auth',
    LANDING_NEW_VIEW: 'LandingNew',
} as const;

export type ServerViewKey = keyof typeof SERVER_VIEWS;
export type ServerViewValue = (typeof SERVER_VIEWS)[ServerViewKey];

export const { NO_AUTH_VIEW, AUTH_VIEW, LANDING_NEW_VIEW } = SERVER_VIEWS;
